<template>
  <div>
    <main class="dashboard user-predash">
      <div class="container-fluid container-fluid--max">
        <h1 class="d-none">Formation</h1>
        <section class="user-dash__opes card">
          <div class="card-body">
            <h2 class="heading-secondary mx-lg-4">Inscription au module de formation</h2>
            <div class="row">
              <div class="col-md mx-lg-4">
                <div class="alert alert-secondary bold rounded-0 text-center my-4" role="alert">
                  Vous devez effectuer la formation pour devenir Centre d'intervention agréé et accéder à votre espace dédié.
                </div>
                <h3 class="heading-secondary pt-3">Statut de l'inscription</h3>
                <div v-if="currentUser.training_session">
                  <p class="badge badge-success font-size-normal">{{ currentUser.training_session.status }}</p>
                  <h3 class="heading-secondary">Date et horaire</h3>
                  <p :class="'text-' + $mainColor">{{ currentUser.training_session.formatted_start_at }}</p>
                  <h3 class="heading-secondary">Lieu</h3>
                  <p :class="'text-' + $mainColor">{{ currentUser.training_session.address }}</p>
                </div>
                <div v-else>
                  <p class="badge badge-danger font-size-normal">Annulée</p>
                  <div class="alert alert-danger" role="alert">
                    La session de formation à laquelle vous étiez inscrit a été modifiée ou annuler. Veuillez en choisir une nouvelle.
                  </div>
                </div>
              </div>
              <div class="col-md mx-lg-4 mt-4 mt-md-0">
                <h3 class="heading-primary">{{ sessionTitle }}</h3>
                <div v-if="currentUser.training_session">
                  <h4 :class="'text-' + $mainColor" class="heading-secondary my-3">{{ currentUser.training_session.name }}</h4>
                  <div class="user-predash__course-descr small">
                    <div v-html="currentUser.training_session.description"></div>
                  </div>
                </div>
                <div class="mt-3" v-else>
                  <vv-observer v-slot="{ invalid }">
                    <vv-provider tag="div" class="form-group mb-0" rules="required" v-slot="{ errors, classes }" name="formation">
                      <label for="coursesList" class="access-form__label">
                        Choisir une session de formation
                        <abbr title="Ce champ est obligatoire">*</abbr>
                      </label>
                      <v-select
                        :options="trainings"
                        label="name"
                        v-model="selectedTraining"
                        :searchable="false"
                        :class="{ 'is-error': classes.invalid }">
                        <span slot="no-options">Aucune formation proposée pour le moment.</span>
                      </v-select>
                      <p class="mb-0">
                        <small class="text-danger">{{ errors[0] }}</small>
                      </p>
                      <div class="user-predash__modal clearfix" v-if="selectedTraining">
                        <button type="button" class="btn btn-link float-right pr-0" data-toggle="modal" data-target="#courseDescrModal">
                          Découvrir la formation
                        </button>
                        <div id="courseDescrModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="courseModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title my-auto" id="courseModalLabel">{{ selectedTraining.name }}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <div v-html="selectedTraining.description"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-3">
                        <button type="submit" class="btn" :class="'btn-' + $mainColor" :disabled="invalid" @click.prevent="subscribe">
                          M'inscrire à cette formation
                        </button>
                      </div>
                    </vv-provider>
                  </vv-observer>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PresignFormation',
  data () {
    return {
      trainings: [],
      selectedTraining: null
    }
  },
  computed: {
    ...mapState(['currentUser']),
    sessionTitle () {
      if (this.currentUser.training_session) {
        return 'Programme de la formation'
      } else {
        return 'Choisir une session de formation'
      }
    }
  },
  async mounted () {
    await this.fetchTrainings()
  },
  methods: {
    fetchTrainings () {
      this.$http.get('/training_sessions').then(resp => {
        this.trainings = resp.data
      })
    },
    subscribe () {
      this.$emit('subscribe', { training_session_id: this.selectedTraining.id })
    }
  }
}
</script>
